import { gql, useQuery } from '@apollo/client';

import { Invoice } from '@work4all/models/lib/Classes/Invoice.entity';

const QUERY = gql`
  query GetOpenPartialInvoicesForCounting($sdObjMemberCode: Int!) {
    getOpenPartialInvoices(sdObjMemberCode: $sdObjMemberCode) {
      id: code
      __typename
    }
  }
`;

type Variables = {
  sdObjMemberCode: number;
};

type Response = {
  getOpenPartialInvoices: Invoice[];
};

export const useOpenPartialInvoicesCount = (
  sdObjMemberCode: number,
  skip: boolean,
  invoiceIdToExclude: number
) => {
  const response = useQuery<Response, Variables>(QUERY, {
    variables: { sdObjMemberCode },
    skip,
  });

  const data = response?.data?.getOpenPartialInvoices ?? [];
  const filteredData = data.filter(
    (invoice) => invoice.id !== invoiceIdToExclude
  );

  return filteredData.length;
};
